import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const createPublishTask = createAsyncThunk('publishTask/createPublishTask', async (payload, thunkAPI) => {
  const { key, ...payloadData } = payload;

  try {
    const response = await axiosInstance.post(`/admin/orders/${key}/publish`, {
      ...payloadData,
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
